<app-stepper
        [headerTitle]="'Estás creando tu cuenta'"
        [headerLength]="mapSteps.length"
        [headerPositionActive]="positionActive"
        [mapTitle]="'MAPA DE CUENTA'"
        [$mapSteps]="$mapStepChange"
        (changePosition)="headerPositionChange($event)">
</app-stepper>
